import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
    getBookmarks,
    delBookmark,
    postBookmark,
    putBookmark,
    createBookmarks,
} from "../services/apiService";
import Icon, { IconType } from "./Icon";
import { BtnState } from "../interfaces/App";
import { setSubTitle } from "../stores/AppReducer";
import type { AppDispatch } from "../stores/AppStore";

interface IProps {
    data?: IBookmarkEntry;
}
export interface IBookmarkEntry {
    guid: string;
    id: number;
    title: string;
    uri?: string;
    children?: IBookmarkEntry[];
}
interface IBookmarkOpen {
    level: number;
    open: string[];
}
type bm = "bookmark" | "folder";

function Bookmarks(props: IProps) {
    const dispatch = useDispatch<AppDispatch>();
    useEffect(() => {
        dispatch(getBookmarks(""));
        dispatch(setSubTitle("Bookmarks"));
    }, []);
    const initialState: IBookmarkOpen = {level: 0, open: []};
    const [state, setState] = useState(initialState);
    const [itemToEdit, setItemToEdit] = useState(null);
    const [menue, setMenue] = useState(null as string);
    const [move, setMove] = useState(null as string);
    const [pattern, setPattern] = useState("");
    const setItem2Edit = (item: IBookmarkEntry) => {
        setItemToEdit(item);
    };
    const handleState = (ev: any, level: number, guid: string, forceAdd?: boolean) => {
        ev.stopPropagation();
        setItemToEdit(null);
        const newState = {level, open: level === state.level ? [...state.open] : []};
        const found = newState.open.findIndex((e: string) => guid === e);
        if (found === -1) {
            newState.open.push(guid);
        } else {
            if (!forceAdd) {
                newState.open.splice(found, 1);
            }
        }
        setState(newState);
        setMenue(null);
    };
    const deleteBookmark = (ev: any, guid: string) => {
        ev.stopPropagation();
        dispatch(delBookmark(guid));
    };
    const allowDrop = (ev: any) => {
        ev.preventDefault();    
    };
    const drag = (ev: any) => {
        const guid = ev.target.id.replace(/anchor_/, "");
        ev.dataTransfer.setData("guid", guid);
        setMove(null);
    };
    const drop = (ev: any, guid: string, type: bm) => {
        ev.preventDefault();
        ev.stopPropagation();
        const idToMove = ev.dataTransfer.getData("guid");
        if (idToMove && !(type === "folder" && guid === idToMove)) {
            dispatch(putBookmark({guid, item: {guid: idToMove}, type}));
        } else {
            const uri = ev.dataTransfer.getData("text");
            if (uri) {
                dispatch(postBookmark({guid, item: {uri}, type}));
            }
        }
    };
    const addBookmark = (ev: any, guid: string, type: bm) => {
        ev.preventDefault();
        ev.stopPropagation();
        if (type === "folder") {
            handleState(ev, state.level, guid);
            dispatch(postBookmark({guid, item: {title: "*new folder"}, type}));
        } else {
            dispatch(postBookmark({guid, item: {uri: "*new bookmark"}, type}));
        }
    };
    const modifyBookmark = (ev: any) => {
        ev.preventDefault();
        dispatch(putBookmark({guid: itemToEdit.guid, item: itemToEdit}));
        setItemToEdit(null);
    };
    const editBookmark = (ev: any, item: IBookmarkEntry) => {
        ev.stopPropagation();
        setItem2Edit(item);
        setMenue(null);
    };
    const toggleMenuBox = (ev: any, guid: string) => {
        ev.stopPropagation();
        ev.preventDefault();
        setMenue(guid === menue ? null : guid);
    };
    const handleUpload = (files: File[]) => {
        dispatch(createBookmarks(files[0]));
    };
    const handleSetMove = (ev: any, guid: string) => {
        ev.preventDefault();
        ev.stopPropagation();
        setMove(guid);
        setMenue(null);
    };
    // *** render functions *** 
    const renderUploadFile = () => {
        return (
            <div>
                <form >
                    <input
                        type="file"
                        multiple={false}
                        onChange={(ev: any) => handleUpload(ev.target.files)}
                    />
                    <button onClick={() => console.log("download ")}>download</button>
                </form>
            </div>
        );
    };
    const renderOpenMenue = (item: IBookmarkEntry, type: bm) => {
        return type === "folder"
            ?   (
                <div className={"right menueBox"} onClick={(ev: any) => toggleMenuBox(ev, item.guid)} >
                    <ul>
                        <li onClick={(ev: any) => editBookmark(ev, item)}>edit</li>
                        <li onClick={(ev: any) => deleteBookmark(ev, item.guid)}>delete</li>
                        <li onClick={(ev: any) => addBookmark(ev, item.guid, "folder")}>add folder</li>
                        <li onClick={(ev: any) => addBookmark(ev, item.guid, "bookmark")}>add bookmark </li>
                        <li onClick={(ev: any) => handleSetMove(ev, item.guid)}>move</li>
                    </ul>
                </div>
            ) : (
                <div className={"right menueBox"} onClick={(ev: any) => toggleMenuBox(ev, item.guid)} >
                    <ul>
                        <li onClick={(ev: any) => editBookmark(ev, item)}>edit</li>
                        <li onClick={(ev: any) => deleteBookmark(ev, item.guid)}>delete</li>
                        <li onClick={(ev: any) => handleSetMove(ev, item.guid)}>move</li>
                    </ul>
                </div>
            );
    };
    const renderMenue = (item: IBookmarkEntry, type: bm) => {
        return (
            <div className={"right"} onClick={(ev: any) => toggleMenuBox(ev, item.guid)}>
                <Icon icon={IconType.asterisk} state={BtnState.active} className={"bookicon"}/>
                {item.guid === menue ? renderOpenMenue(item, type) : null }
            </div>
        );
    };
    const renderEditBookmark = () =>  {
        return (
            <div key={"ref_edit"}>
                <form onSubmit={(ev: any) => modifyBookmark(ev)}>
                    <input value={itemToEdit.title} onChange={(ev: any) => setItem2Edit({...itemToEdit, title: ev.target.value})} />
                    <input value={itemToEdit.uri} onChange={(ev: any) => setItem2Edit({...itemToEdit, uri: ev.target.value})} />
                    <button type={"submit"} className="right" >
                        <Icon icon={IconType.save} state={BtnState.active} className={"bookicon"}/>
                    </button>
                </form>
            </div>
        );
    };
    const renderEditFolder = () =>  {
        return (
            <div key={"ref_edit"}>
                <form onSubmit={(ev: any) => modifyBookmark(ev)}>
                    <input value={itemToEdit.title} onChange={(ev: any) => setItemToEdit({...itemToEdit, title: ev.target.value})} />
                    <button type={"submit"} className="right" >
                        <Icon icon={IconType.save} state={BtnState.active} className={"bookicon"}/>
                    </button>
                </form>
            </div>
        );
    };
    const renderBookmark = (entry: IBookmarkEntry, idx: number) => {
        
        const isDraggable = move !== null && move === entry.guid ? true : false;
        const match = pattern.length === 0 || (entry.title?.toLowerCase().indexOf(pattern) > -1 || entry.uri?.toLowerCase().indexOf(pattern) > -1);
        return match ? (
            <div
                key={`ref_ ${idx}`}
                onDragOver={(ev: any) => allowDrop(ev)} 
                onDrop={(ev: any) => drop(ev, entry.guid, "bookmark")}
            >
                <div
                    id={`anchor_${entry.guid}`}
                    draggable={isDraggable}
                    onDragStart={(ev: any) => drag(ev)}
                    className={`left dragable ${isDraggable ? "hl" : ""}`}
                >
                    <Icon icon={IconType.arrowRight} state={BtnState.active} className={"bookicon"}/>
                    <a
                        href={entry.uri}
                        target="_blank"
                        draggable={false}
                        onDragStart={(ev: any) => ev.preventDefault()}
                    >
                        {entry.title}
                    </a>
                    {renderMenue(entry, "bookmark")}
                </div>
            </div>
        ) : (null);
    };
    const renderFolder = (entry: IBookmarkEntry, level: number) => {
        const className = state.open.find((e: string) => entry.guid === e) ? "openGroup" : "closedGroup";
        const isDraggable = move === entry.guid ? true : false;
        return (
            <div 
                key={`folder ${entry.guid}`}
                className={`bookmarks ${isDraggable ? "hl" : ""}`}
                onDragOver={(ev: any) => allowDrop(ev)}
                onDrop={(ev: any) => drop(ev, entry.guid, "folder")}
            >
                <h3
                    id={`anchor_${entry.guid}`}
                    draggable={isDraggable}
                    onDragStart={(ev: any) => drag(ev)}
                    onClick={(ev: any) => handleState(ev, level, entry.guid)}
                >
                    <Icon icon={IconType.globe} state={BtnState.active} className={"bookicon"}/>
                    {entry.title}
                    {renderMenue(entry, "folder")}
                </h3>
                <div className={className}>
                    {entry.children && entry.children.map(renderList)}
                </div>
                <div className="clear"/>
            </div>
        );
    };
    const editItem = (entry: IBookmarkEntry) => {
       return  entry.uri
            ? renderEditBookmark()
            : renderEditFolder();
    };
    const renderItem = (entry: IBookmarkEntry, idx: number) => {
        return entry.uri
            ? renderBookmark(entry, idx)
            : renderFolder(entry, state.level);
    };
    const renderList = (entry: IBookmarkEntry, idx: number) => {
        return itemToEdit && (itemToEdit.guid === entry.guid)
            ? editItem(entry)
            : renderItem(entry, idx);
    };
    return (
        <div className="page">
            <form onSubmit={(ev: any) => ev.preventDefault()} >
                <input value={pattern.toLowerCase()} onChange={(ev: any) => setPattern(ev.target.value)}/>
                <input type = "submit" onClick={() => {
                    const ll: string[] = [];
                    getAllFolders(props.data?.children, ll, pattern);
                    setState({...state, open: ll});
                }} value = "A" />
                <input type = "reset" onClick={() => {setPattern(''); setState({...state, open: []}); }} value = "C" />
            </form>
            {props.data?.children && props.data.children.map(renderList)}
            <div className="clear"/>
            {renderUploadFile()}
        </div>
    );
}

export function changeBookmarks(data: IBookmarkEntry[], guid: string, item: IBookmarkEntry, type: string, newGuid?: string) {
    let found = -1;
    let rc = 0;
    for (let i = 0; i < data.length; i++) {
        if (found === -1 && !rc) {
            if (data[i].guid === guid) {
                found = i;
            } else {
                if (data[i].children) {
                    rc = changeBookmarks(data[i].children, guid, item, type, newGuid);
                }
            }
        }
    }
    if (found > -1) {
        if (!item) {
            data.splice(found, 1);           // delete
        } else if (item.guid) {
            data.splice(found, 1, item);     // update
        } else if (type === "folder") {      // insert folder
            item.guid = newGuid;
            const parent: IBookmarkEntry[] = data.splice(found, 1, data[found]);
            if (!parent[0].children) {
                parent[0].children = [];
            }
            parent[0].children.push(item);
        } else {
            item.guid = newGuid;
            data.splice(found + 1, 0, item); // insert after
        }
        return 1;
    }
    return rc;
}
export function getBookmark(data: IBookmarkEntry[], guid: string): IBookmarkEntry {
    let found;
    for (const item of data) {
        if (! found) {
            if (item.guid === guid) {
                found = item;
            } else {
                if (item.children) {
                    found = getBookmark(item.children, guid);
                }
            }
        }
    }
    return found;
}
export function getAllFolders(data: IBookmarkEntry[], list: string[], pattern: string): boolean {
    let found = false;
    for (const item of data) {
        if (!pattern?.length ||
            (item.uri && pattern?.length > 0 && (item.uri.toLowerCase().indexOf(pattern) > -1 || item.title.toLowerCase().indexOf(pattern) > -1))
        ) {
            found = true;
        }
        if (item.children) {
            if (getAllFolders(item.children, list, pattern)) {
                list.push(item.guid);
                found = true;
            }
        }
    }
    return found;
}

export default (Bookmarks);
